import ModernContactUs from '../../../common/components/ModernContactUs/ModernContactUs';

const ContactUs = () => {
  return <ModernContactUs />;
};

export default ContactUs;
